import http from "../components/config/axiosConfig";

const headers = {
  "container-id": "SITE",
    "container-type": "SITE"
}

const generateSecretKey = (email) => {
  return http.get(`/mfa/generateTotpSecretKey`, {
    headers: headers,
    params: {
      userEmail: email
    }
  })
}

const enable = (payload) => {
  return http.post(`/mfa/enable`, payload, {
    headers: headers
  })
}

const validate = (payload) => {
  return http.post(`/mfa/validateToken`, payload, {
    headers: headers
  })
}

const reset = (payload) => {
  return http.put(`/mfa/reset`, payload, {
    headers: headers
  })
}

export default {
  generateSecretKey,
  enable,
  reset,
  validate
}
